module.exports = __webpack_public_path__ + "img/txt.7edf0523.png";